import CarrinhoItemModel from "./CarrinhoItemModel";
import MockData from "./MockData";
import ProdutoModel from "./ProdutoModel";
import ConteudoModel from "./ConteudoModel";
import ListaModel from "./ListaModel";
import NavegadorUtil from "../util/NavegadorUtil";
import ListaItemModel from "./ListaItemModel";
import CarrinhoModel from "./CarrinhoModel";
import C5CarrinhoDAO from "../dataAccess/C5/C5CarrinhoDAO";
import LojaModel from "./LojaModel";
import CartaoCreditoModel from "./CartaoCreditoModel";
import AgendamentoRetiradaModel from "./AgendamentoRetiradaModel";
import AlertaModel from "./AlertaModel";
import UsuarioModel from "./UsuarioModel";
import C5ListaUsuarioDAO from "../dataAccess/C5/C5ListaUsuarioDAO";
import CriptoUtil from "../util/CriptoUtil";
import TelemetriaServiceUtil from "../util/TelemetriaServiceUtil";
import DataUtil from "../util/DataUtil";

class AppState {
  static mockKey: string = "mockState";
  static lojaSelecionadaKey: string = "lojaSelecionada";
  static carrinhoItemsKey: string = "carrinhoItems";
  static conteudosCurtidosKey: string = "conteudosCurtidos";
  static produtoBQKey: string = "produtoBQ";
  static produtoAlternativoKey: string = "produtoAlternativo";
  static maioridadeKey: string = "maioridade";
  static agendamentoRetiradaKey: string = "agendamentoRetirada";
  static modalidadeEntregaKey: string = "modalidadeEntrega";
  static agendamentoDescricaoKey: string = "agendamentoDescricao";
  static cartaoCreditoKey: string = "cartaoCredito";
  static usuarioLogadoKey: string = "usuarioLogado";
  static metodoEntregaKey: string = "metodoEntrega";
  static freteTipoKey: string = "freteTipo";
  static seloKey: string = "selo";
  static alerta?: AlertaModel;

  static getMockData(): boolean {
    const mockState: string | null = CriptoUtil.getInstance().getItem(
      this.mockKey
    );
    if (mockState) {
      return JSON.parse(mockState);
    }
    return true;
  }

  static setMockData(flag: boolean): void {
    CriptoUtil.getInstance().setItem(this.mockKey, JSON.stringify(flag));
  }

  static async addListaItem(
    listaId: string,
    produto: ProdutoModel,
    notas?: string
  ): Promise<boolean> {
    const listas: ListaModel[] = await this.getListas();
    const lista: ListaModel | undefined = listas.find(
      (l) => l.listaId === listaId.toString()
    );

    if (lista) {
      if (!lista.items) {
        lista.items = [];
      }

      const listaItem: ListaItemModel[] = lista.items.filter(
        (i) => i.produto.produtoId === produto.produtoId
      );

      if (listaItem.length === 0) {
        const logado: UsuarioModel | null = this.getUsuarioLogado();

        if (logado) {
          return await C5ListaUsuarioDAO.getInstance()
            .cadastrarItem(logado, listaId, produto, 1)
            .then((item: any) => {
              lista.items.push({
                listaItemId: MockData.uuidv4(),
                produto,
                quantidade: 1,
                adicionado: new Date(),
                notas,
              } as ListaItemModel);
              return true;
            });
        } else {
          NavegadorUtil.alertaModal(
            "É necessário estar logado para fazer esta operação."
          );
          return false;
        }
      } else {
        return false;
      }
    }
    return false;
  }

  static async getLista(id: string): Promise<ListaModel> {
    const listas: ListaModel[] = await this.getListas();
    const item: ListaModel | undefined = listas.find((l) => l.listaId === id);
    if (item) {
      return item;
    } else {
      throw new Error("Lista não encontrada");
    }
  }

  static async remLista(id: string): Promise<void> {
    const listas: ListaModel[] = await this.getListas();
    const lista: ListaModel | undefined = listas.find((l) => l.listaId === id);

    if (lista) {
      const logado: UsuarioModel | null = this.getUsuarioLogado();

      if (logado) {
        return C5ListaUsuarioDAO.getInstance()
          .removerLista(logado, id)
          .catch((err: any) => {
            NavegadorUtil.alertaModal(
              "Não foi possível excluir a lista solicitada."
            );
          });
      } else {
        NavegadorUtil.alertaModal("Lista não encontrada.");
      }
    }
  }

  static async getListas(): Promise<ListaModel[]> {
    const usuario: UsuarioModel | null = this.getUsuarioLogado();
    const loja: LojaModel | null = this.getLojaSelecionada();

    if (!usuario || !loja) {
      return [];
    } else {
      return C5ListaUsuarioDAO.getInstance().obterListas(usuario, loja);
    }
  }

  static async addLista(nome: string): Promise<ListaModel | null> {
    if (nome === "") {
      return null;
    }

    const lista: ListaModel = new ListaModel();
    lista.nome = nome;
    lista.listaId = MockData.uuidv4();

    const logado: UsuarioModel | null = this.getUsuarioLogado();
    if (logado) {
      const listas: ListaModel[] = await this.getListas();
      const outras: ListaModel[] = listas.filter(
        (l) => l.nome.trim().toLowerCase() === nome.trim().toLowerCase()
      );
      if (outras.length === 0) {
        return C5ListaUsuarioDAO.getInstance()
          .cadastrarLista(logado, nome)
          .then((ret: any) => {
            lista.listaId = ret.data.ClientShopList;
            return lista;
          })
          .catch((err: any) => {
            throw new Error("Não foi possível criar a lista solicitada.");
          });
      } else {
        throw new Error("Já existe outra lista com este nome");
      }
    } else {
      throw new Error("Necessário estar logado para criar uma lista");
    }
  }

  static async setLojaSelecionada(loja: LojaModel): Promise<void> {
    CriptoUtil.getInstance().setItem(
      this.lojaSelecionadaKey,
      JSON.stringify(loja)
    );
  }

  static resetLojaSelecionada(): void {
    CriptoUtil.getInstance().removeItem(this.lojaSelecionadaKey);
  }
  static getLojaSelecionada(): LojaModel | null {
    const loja: string | null = CriptoUtil.getInstance().getItem(
      this.lojaSelecionadaKey
    );
    if (loja) {
      return JSON.parse(loja);
    } else {
      return null;
    }
  }

  static carrinhoMensagem(produtoId: string): string {
    const carrinho: CarrinhoModel = AppState.getCarrinho();
    const item: CarrinhoItemModel | undefined = carrinho.carrinhoItens.find(
      (c: CarrinhoItemModel) => c.produto.produtoId === produtoId
    );

    if (item) {
      if (item.quantidade === 0) {
        return `Item removido do carrinho`;
      } else {
        if (item.quantidade === 1) {
          return `1 unidade do produto no carrinho`;
        } else {
          return `${item.quantidade} unidades do produto no carrinho`;
        }
      }
    } else {
      return `Item removido do carrinho`;
    }
  }

  static limparCarrinho(): void {
    CriptoUtil.getInstance().removeItem(this.carrinhoItemsKey);
    CriptoUtil.getInstance().removeItem(this.agendamentoDescricaoKey);
    CriptoUtil.getInstance().removeItem(this.agendamentoRetiradaKey);
    CriptoUtil.getInstance().removeItem(this.produtoAlternativoKey);
  }

  static async addCarrinhoItem(
    produto: ProdutoModel,
    observacao?: string
  ): Promise<void> {
    if (typeof(observacao) !== 'string') {
      observacao = '';
    }
    
    const carrString: string | null = CriptoUtil.getInstance().getItem(
      this.carrinhoItemsKey
    );

    const usuario = AppState.getUsuarioLogado();
    if (usuario) {
      const requerMaioridade = await ProdutoModel.requerMaioridade(produto);
      if (requerMaioridade && DataUtil.getIdade(usuario.nascimento) < 18) {
        // eslint-disable-next-line
        throw 'Este produto requer maioridade (idade do cadastro menor que 18 anos completos)';
      }
    }

    if (carrString) {
      const carrinho: CarrinhoModel = JSON.parse(carrString) as CarrinhoModel;

      const carrinhoItem:
        | CarrinhoItemModel
        | undefined = carrinho.carrinhoItens.find(
        (c: CarrinhoItemModel) => c.produto.produtoId === produto.produtoId
      );

      if (carrinhoItem) {
        ++carrinhoItem.quantidade;

        if (!AppState.getMockData()) {
          await C5CarrinhoDAO.getInstance().updateCarrinhoItem(carrinhoItem);
        }
      } else {
        let maiorId: number = 0;
        for (const ci of carrinho.carrinhoItens) {
          if (maiorId < +ci.carrinhoItemId) {
            maiorId = +ci.carrinhoItemId;
          }
        }
        const carrinhoItemNovo: CarrinhoItemModel = {
          carrinhoItemId: String(maiorId + 1),
          produto,
          quantidade: 1,
          adicionado: new Date(),
          notas: observacao,
        } as CarrinhoItemModel;
        if (!AppState.getMockData()) {
          await C5CarrinhoDAO.getInstance().updateCarrinhoItem(
            carrinhoItemNovo
          );
        }
        carrinho.carrinhoItens.push(carrinhoItemNovo);
      }

      CriptoUtil.getInstance().setItem(
        this.carrinhoItemsKey,
        JSON.stringify(carrinho)
      );
    } else {
      const carrinhoItens: CarrinhoItemModel[] = [];

      carrinhoItens.push({
        carrinhoItemId: "1",
        produto,
        quantidade: 1,
        adicionado: new Date(),
        notas: observacao,
      } as CarrinhoItemModel);

      let carrinho: CarrinhoModel;
      if (AppState.getMockData()) {
        carrinho = {
          carrinhoId: MockData.uuidv4(),
          carrinhoItens,
        } as CarrinhoModel;
      } else {
        const carrinhoId: string = await C5CarrinhoDAO.getInstance().addCarrinhoItem(
          carrinhoItens[0]
        );
        carrinho = {
          carrinhoId,
          carrinhoItens,
        } as CarrinhoModel;
      }

      CriptoUtil.getInstance().setItem(
        this.carrinhoItemsKey,
        JSON.stringify(carrinho)
      );
    }
  }

  static async decCarrinhoItem(
    produto: ProdutoModel,
    observacao?: string
  ): Promise<void> {
    const carrString: string | null = CriptoUtil.getInstance().getItem(
      this.carrinhoItemsKey
    );
    if (carrString) {
      const carrinho: CarrinhoModel = JSON.parse(carrString) as CarrinhoModel;

      // const usuario = AppState.getUsuarioLogado();
      // if (usuario) {
      //   const requerMaioridade = await ProdutoModel.requerMaioridade(produto);
        
      //   if (requerMaioridade && DataUtil.getIdade(usuario.nascimento) < 18) {
      //     eslint-disable-next-line
      //     throw 'Este produto requer maioridade (idade do cadastro menor que 18 anos completos)';
      //   }
      // }
  
      const carrinhoItem:
        | CarrinhoItemModel
        | undefined = carrinho.carrinhoItens.find(
        (c: CarrinhoItemModel) => c.produto.produtoId === produto.produtoId
      );

      if (carrinhoItem) {
        if (carrinhoItem.quantidade > 1) {
          carrinhoItem.notas = observacao ? observacao : "";
          carrinhoItem.quantidade--;
          if (!AppState.getMockData()) {
            await C5CarrinhoDAO.getInstance().updateCarrinhoItem(carrinhoItem);
          }
        } else {
          if (!AppState.getMockData()) {
            await C5CarrinhoDAO.getInstance().remCarrinhoItem(carrinhoItem);
          }
          carrinhoItem.quantidade--;
          carrinho.carrinhoItens.splice(
            carrinho.carrinhoItens.indexOf(carrinhoItem),
            1
          );
        }
      }

      CriptoUtil.getInstance().setItem(
        this.carrinhoItemsKey,
        JSON.stringify(carrinho)
      );
    }
  }

  static async remCarrinhoItem(produto: ProdutoModel): Promise<void> {
    const carrString: string | null = CriptoUtil.getInstance().getItem(
      this.carrinhoItemsKey
    );
    if (carrString) {
      const carrinho: CarrinhoModel = JSON.parse(carrString) as CarrinhoModel;

      const carrinhoItem:
        | CarrinhoItemModel
        | undefined = carrinho.carrinhoItens.find(
        (c: CarrinhoItemModel) => c.produto.produtoId === produto.produtoId
      );

      if (carrinhoItem) {
        carrinho.carrinhoItens.splice(carrinho.carrinhoItens.indexOf(carrinhoItem), 1);
        if (!AppState.getMockData()) {
          await C5CarrinhoDAO.getInstance().remCarrinhoItem(carrinhoItem);
        }
      }

      CriptoUtil.getInstance().setItem(
        this.carrinhoItemsKey,
        JSON.stringify(carrinho)
      );
    }
  }

  static getCarrinho(): CarrinhoModel {
    const carrString: string | null = CriptoUtil.getInstance().getItem(
      this.carrinhoItemsKey
    );
    if (carrString) {
      return JSON.parse(carrString);
    } else {
      return {
        carrinhoId: MockData.uuidv4(),
        carrinhoItens: [],
      } as CarrinhoModel;
    }
  }

  static setProdutoAlternativo(produtoAlternativo: string): void {
    CriptoUtil.getInstance().setItem(
      this.produtoAlternativoKey,
      JSON.stringify(produtoAlternativo)
    );
  }

  static getProdutoAlternativo(): string | null {
    const prod: string | null = CriptoUtil.getInstance().getItem(
      this.produtoAlternativoKey
    );
    return prod ? JSON.parse(prod) : prod;
  }

  static setMaioridade(maioridade: boolean): void {
    
    const usuario = AppState.getUsuarioLogado();
    if (TelemetriaServiceUtil.appInsights) {
      TelemetriaServiceUtil.appInsights.trackEvent(
        { name: "Maioridade", },
        { maioridade, usuario }
      );
    }

    CriptoUtil.getInstance().setItem(
      this.maioridadeKey,
      JSON.stringify(maioridade ? "S" : "N")
    );
    
  }

  static getMaioridade(): boolean {
    const maioridade: string | null = CriptoUtil.getInstance().getItem(
      this.maioridadeKey
    );
    return maioridade ? JSON.parse(maioridade) === "S" : false;
  }


  static setFreteTipoId(freteTipoId: number): void {
    CriptoUtil.getInstance().setItem(
      this.freteTipoKey,
      JSON.stringify(freteTipoId)
    );
  }

  static getFreteTipoId(): number | null {
    const prod: string | null = CriptoUtil.getInstance().getItem(
      this.freteTipoKey
    );
    return prod ? JSON.parse(prod) : 0;
  }

  static setMetodoEntrega(metodoEntrega: string): void {
    CriptoUtil.getInstance().setItem(
      this.metodoEntregaKey,
      JSON.stringify(metodoEntrega)
    );
  }

  static getMetodoEntrega(): string | null {
    const prod: string | null = CriptoUtil.getInstance().getItem(
      this.metodoEntregaKey
    );
    return prod ? JSON.parse(prod) : prod;
  }

  static setProdutoBemQuerer(produtosBemQuerer: ProdutoModel[]): void {
    CriptoUtil.getInstance().setItem(
      this.produtoBQKey,
      JSON.stringify(produtosBemQuerer)
    );
  }

  static getProdutoBemQuerer(): ProdutoModel[] | null {
    const prod: string | null = CriptoUtil.getInstance().getItem(
      this.produtoBQKey
    );
    return prod ? JSON.parse(prod) : prod;
  }

  static setAgendamentoRetirada(
    agendamentoRetirada: AgendamentoRetiradaModel
  ): void {
    CriptoUtil.getInstance().setItem(
      this.agendamentoRetiradaKey,
      JSON.stringify(agendamentoRetirada)
    );
  }

  static getAgendamentoRetirada(): AgendamentoRetiradaModel | null {
    const prod: string | null = CriptoUtil.getInstance().getItem(
      this.agendamentoRetiradaKey
    );
    return prod ? JSON.parse(prod) : prod;
  }

  static setModalidadeEntregaCompra(
    modalidade: string
  ): void {
    CriptoUtil.getInstance().setItem(
      this.modalidadeEntregaKey,
      JSON.stringify(modalidade)
    );
  }

  static getModalidadeEntregaCompra(): string | null {
    const prod: string | null = CriptoUtil.getInstance().getItem(
      this.modalidadeEntregaKey
    );
    return prod ? JSON.parse(prod) : prod;
  }

  static setDescricaoEntrega(descricao: string): void {
    CriptoUtil.getInstance().setItem(
      this.agendamentoDescricaoKey,
      JSON.stringify(descricao)
    );
  }

  static getDescricaoEntrega(): string | null {
    const prod: string | null = CriptoUtil.getInstance().getItem(
      this.agendamentoDescricaoKey
    );
    return prod ? JSON.parse(prod) : prod;
  }

  static setCartaoCredito(cartaoCredito: CartaoCreditoModel): void {
    CriptoUtil.getInstance().setItem(
      this.cartaoCreditoKey,
      JSON.stringify(cartaoCredito)
    );
  }

  static getCartaoCredito(): CartaoCreditoModel | null {
    const cc: string | null = CriptoUtil.getInstance().getItem(
      this.cartaoCreditoKey
    );
    return cc ? JSON.parse(cc) : null;
  }

  static remCartaoCredito(): void {
    CriptoUtil.getInstance().removeItem(this.cartaoCreditoKey);
  }

  static async setCarrinhoItemNota(
    produtoId: string,
    nota: string
  ): Promise<void> {
    const carrinho: CarrinhoModel = this.getCarrinho();
    const carrinhoItem:
      | CarrinhoItemModel
      | undefined = carrinho.carrinhoItens.find(
      (i: CarrinhoItemModel) =>
        i.produto.produtoId.toString() === produtoId.toString()
    );
    if (carrinhoItem) {
      carrinhoItem.notas = nota;
      await C5CarrinhoDAO.getInstance().updateCarrinhoItem(carrinhoItem);
    }
    CriptoUtil.getInstance().setItem(
      this.carrinhoItemsKey,
      JSON.stringify(carrinho)
    );
  }

  static forceUpdateCarrinho(carrinho: CarrinhoModel): void {
    CriptoUtil.getInstance().setItem(
      this.carrinhoItemsKey,
      JSON.stringify(carrinho)
    );
  }

  static async setListaItemNota(
    listaId: string,
    produtoId: string,
    nota: string
  ): Promise<void> {
    const listas: ListaModel[] = await this.getListas();
    const lista: ListaModel = listas.filter((l) => l.listaId === listaId)[0];
    const listaItem: ListaItemModel[] = lista.items.filter(
      (l: ListaItemModel) => l.produto.produtoId === produtoId
    );

    if (listaItem.length === 1) {
      listaItem[0].notas = nota;
    }
  }

  static toggleCurtir(conteudo: ConteudoModel): boolean {
    let retVal: boolean = true;
    const conteudoString: string | null = CriptoUtil.getInstance().getItem(
      this.conteudosCurtidosKey
    );
    let conteudos: ConteudoModel[] = [];

    if (conteudoString) {
      conteudos = JSON.parse(conteudoString) as ConteudoModel[];
      const conteudoEncontrado: ConteudoModel[] = conteudos.filter(
        (c) => c.conteudoId === conteudo.conteudoId
      );

      if (conteudoEncontrado.length === 0) {
        conteudo.curtidoEm = new Date();
        conteudos.push(conteudo);
      } else {
        conteudos.splice(conteudos.indexOf(conteudoEncontrado[0]), 1);
        retVal = false;
      }
    } else {
      conteudos = [conteudo];
    }

    CriptoUtil.getInstance().setItem(
      this.conteudosCurtidosKey,
      JSON.stringify(conteudos)
    );
    return retVal;
  }

  static updateCurtidos(conteudos: ConteudoModel[]): void {
    conteudos.forEach((c: ConteudoModel) => {
      if (this.foiCurtido(c)) {
        c.curtidoEm = new Date();
      }
    });
  }

  static isCurtido(conteudo: ConteudoModel): boolean {
    const conteudoString: string | null = CriptoUtil.getInstance().getItem(
      this.conteudosCurtidosKey
    );
    let conteudos: ConteudoModel[] = [];

    if (conteudoString) {
      conteudos = JSON.parse(conteudoString) as ConteudoModel[];
      const conteudoEncontrado: ConteudoModel[] = conteudos.filter(
        (c) => c.conteudoId === conteudo.conteudoId
      );

      return conteudoEncontrado.length > 0;
    }

    return false;
  }

  static async incListaItem(
    listaId: string,
    produto: ProdutoModel,
    observacao?: string
  ): Promise<void> {
    const lista: ListaModel | undefined = await this.getLista(listaId);

    const logado: UsuarioModel | null = this.getUsuarioLogado();

    if (!logado) {
      NavegadorUtil.alertaModal(
        "É necessário estar logado para fazer esta operação."
      );
      return;
    }

    if (lista) {
      const listaItem: ListaItemModel | undefined = lista.items.find(
        (l: ListaItemModel) => l.produto.produtoId === produto.produtoId
      );

      if (listaItem) {
        await C5ListaUsuarioDAO.getInstance().atualizarItem(
          logado,
          listaId,
          produto,
          ++listaItem.quantidade
        );
      } else {
        await C5ListaUsuarioDAO.getInstance().cadastrarItem(
          logado,
          listaId,
          produto,
          1
        );
      }
    }
  }

  static async decListaItem(
    listaId: string,
    produto: ProdutoModel,
    observacao?: string
  ): Promise<string> {
    const lista: ListaModel | undefined = await this.getLista(listaId);
    const logado: UsuarioModel | null = this.getUsuarioLogado();

    if (!logado) {
      return "É necessário estar logado para fazer esta operação.";
    }

    if (lista) {
      const listaItem: ListaItemModel | undefined = lista.items.find(
        (l: ListaItemModel) => l.produto.produtoId === produto.produtoId
      );

      if (listaItem) {
        listaItem.quantidade--;
        if (listaItem.quantidade > 0) {
          await C5ListaUsuarioDAO.getInstance().atualizarItem(
            logado,
            listaId,
            produto,
            listaItem.quantidade
          );
          return "Quantidade atualizada com sucesso";
        } else {
          await C5ListaUsuarioDAO.getInstance().removerItem(
            logado,
            listaId,
            produto
          );
          return "Produto removido com sucesso";
        }
      } else {
        await C5ListaUsuarioDAO.getInstance().removerItem(
          logado,
          listaId,
          produto
        );
        return "Produto removido com sucesso";
      }
    }
    return "Quantidade atualizada com sucesso";
  }

  static async remListaItem(
    listaId: string,
    produto: ProdutoModel
  ): Promise<void> {
    const listas: ListaModel[] = await this.getListas();
    const lista: ListaModel | undefined = listas.find(
      (l) => l.listaId === listaId
    );
    if (lista) {
      const listaItem: ListaItemModel | undefined = lista.items.find(
        (l: ListaItemModel) => l.produto.produtoId === produto.produtoId
      );

      if (listaItem) {
        const logado: UsuarioModel | null = this.getUsuarioLogado();

        if (logado) {
          await C5ListaUsuarioDAO.getInstance().removerItem(
            logado,
            listaId,
            produto
          );
        }
      }
    }
  }

  static foiCurtido(conteudo: ConteudoModel): boolean {
    const conteudoString: string | null = CriptoUtil.getInstance().getItem(
      this.conteudosCurtidosKey
    );
    if (conteudoString) {
      const conteudos: ConteudoModel[] = JSON.parse(conteudoString);
      return conteudos.some((c) => c.conteudoId === conteudo.conteudoId);
    } else {
      return false;
    }
  }

  static getCurtidos(): ConteudoModel[] {
    const conteudoString: string | null = CriptoUtil.getInstance().getItem(
      this.conteudosCurtidosKey
    );
    if (conteudoString) {
      const conteudos: ConteudoModel[] = JSON.parse(conteudoString);
      return conteudos;
    } else {
      return [];
    }
  }

  static fecharAlerta(component: React.Component): void {
    if (AppState.alerta) {
      AppState.alerta.exibirModal = false;
    }
    component.forceUpdate();
  }

  static getAlerta(): AlertaModel | undefined {
    return AppState.alerta;
  }
  static setAlerta(alerta: AlertaModel): void {
    AppState.alerta = alerta;
  }

  static setUsuarioLogado(usuario: UsuarioModel | null): void {
    CriptoUtil.getInstance().setItem(
      this.usuarioLogadoKey,
      JSON.stringify(usuario)
    );
  }

  static getUsuarioLogado(): UsuarioModel | null {
    const usuarioString: string | null = CriptoUtil.getInstance().getItem(
      this.usuarioLogadoKey
    );
    if (usuarioString) {
      return JSON.parse(usuarioString);
    } else {
      return null;
    }
  }

  static setSelo(produtoId: number, index: number, url: string) {
    const seloString: string | null = CriptoUtil.getInstance().getItem(
      this.seloKey
    );
    let seloItem = [];

    if (seloString) {
      seloItem = JSON.parse(seloString);

      if (!seloItem.some((s: any) => s.produtoId === produtoId && s.index === index && s.url === url)) {
        seloItem.push({
          produtoId,
          index,
          url
        });
      }
    } else {
      seloItem.push({
        produtoId,
        index,
        url
      });
    }

    CriptoUtil.getInstance().setItem(
      this.seloKey,
      JSON.stringify(seloItem)
    );
  }

  static getSelos(produtoId: number) {
    const seloString: string | null = CriptoUtil.getInstance().getItem(
      this.seloKey
    );
    if (seloString) {
      const seloItem = JSON.parse(seloString);
      return seloItem.filter((s: any) => s.produtoId === produtoId);
    }
    return null;
  }
}

export default AppState;
